import type { CreateDatetime } from './valueObjects/createDatetime';
import type { ParentId } from './valueObjects/parentId';
import type { DeviceJson } from '@/types/domain/device/entities/deviceEntity';

import { Entity } from '@/domain/entity';
import { DeleteType } from '@/domain/entityRepositoryBase';
import {
  EntityName,
} from '@/infra/appsync';

/** デバイスプロパティ */
export type DeviceProps = {
  /** 親ID */
  parentId: ParentId,
  /** 作成日時 */
  createDatetime: CreateDatetime,
  /** トークン */
  token: string,
}

export class DeviceEntity extends Entity<
  DeviceProps,
  DeviceJson
> {
  get deleteType(): DeleteType {
    return DeleteType.Dt;
  }

  get deleteKey(): string {
    return this.getFutureMonth(this.createDatetime.value, 3).toJSON();
  }

  toJsonData(): DeviceJson {
    return {
      parentId: this.parentId.value,
      createDatetime: this.createDatetime.value.toJSON(),
      token: this.token,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityName {
    return EntityName.WagakoAppDeviceDeviceEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return this.token;
  }

  /**
   * 親ID
   */
  get parentId(): ParentId {
    return this._value.parentId;
  }

  /**
   * 作成日時
   */
  get createDatetime(): CreateDatetime {
    return this._value.createDatetime;
  }

  /**
   * 作成日時
   */
  set createDatetime(createDatetime: CreateDatetime) {
    this.createDatetime = createDatetime;
  }

  /**
   * トークン
   */
  get token(): string {
    return this._value.token;
  }

  /**
   * トークン
   */
  set token(token: string) {
    this.token = token;
  }
}
